import * as React from "react";
import { useState, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import {
	StepLabel,
	Step,
	Stepper,
	Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import PersonalInfo from "./PersonalInfor";
import BusinessInfo from "./BusinessInfo";
import BankInfo from "./BankInfo";
import LinkedMarketplaces from "./LinkedMarketplaces";
// import RiskAnalysis from "./RiskAnalysis";
import UploadandSign from "./UploadandSign";
import Completed from "./Completed";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AodIcon from "@mui/icons-material/Aod";
import BusinessIcon from "@mui/icons-material/Business";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import AnalyticsIcon from "@mui/icons-material/Analytics";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckIcon from "@mui/icons-material/Check";
import StepConnector, {
	stepConnectorClasses,
} from "@mui/material/StepConnector";
import Check from "@mui/icons-material/Check";
// import { GreenContainedButton } from "../../components/ui/Buttons";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useEffect } from "react";
import { GetUserDetails } from "../../services/auth.services";
import { useNavigate } from "react-router-dom";

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
	color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
	display: "flex",
	height: 22,
	alignItems: "center",
	...(ownerState.active && {
		color: "#03AD47",
	}),
	"& .QontoStepIcon-completedIcon": {
		color: "#03AD47",
		zIndex: 1,
		fontSize: 18,
	},
}));

function QontoStepIcon(props) {
	const { active, completed, className } = props;

	return (
		<QontoStepIconRoot ownerState={{ active }} className={className}>
			{completed ? (
				<Check className="QontoStepIcon-completedIcon" />
			) : (
				<div className="QontoStepIcon-circle" />
			)}
		</QontoStepIconRoot>
	);
}

QontoStepIcon.propTypes = {
	/**
	 * Whether this step is active.
	 * @default false
	 */
	active: PropTypes.bool,
	className: PropTypes.string,
	/**
	 * Mark the step as completed. Is passed to child components.
	 * @default false
	 */
	completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
	[`&.${stepConnectorClasses.alternativeLabel}`]: {
		top: 22,
	},
	[`&.${stepConnectorClasses.active}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			background: "#03AD47",
		},
	},
	[`&.${stepConnectorClasses.completed}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			background: "#03AD47",
		},
	},
	[`& .${stepConnectorClasses.line}`]: {
		height: 3,
		border: 0,
		backgroundColor:
			theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
		borderRadius: 1,
	},
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
	color: "#C3C7D3",
	zIndex: 1,
	width: 50,
	height: 50,
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	...(ownerState.active && {
		color: "#03AD47",
	}),
	...(ownerState.completed && {
		color: "#03AD47",
	}),
}));

function ColorlibStepIcon(props) {
	const { active, completed, className } = props;

	const icons = {
		1: <AccountCircleIcon fontSize="large" />,
		2: <AodIcon fontSize="large" />,
		3: <BusinessIcon fontSize="large" />,
		4: <AccountBalanceIcon fontSize="large" />,
		// 5: <AnalyticsIcon fontSize="large" />,
		5: <CloudUploadIcon fontSize="large" />,
		6: <CheckIcon fontSize="large" />,
	};

	return (
		<ColorlibStepIconRoot
			ownerState={{ completed, active }}
			className={className}
		>
			{icons[String(props.icon)]}
		</ColorlibStepIconRoot>
	);
}

ColorlibStepIcon.propTypes = {
	/**
	 * Whether this step is active.
	 * @default false
	 */
	active: PropTypes.bool,
	className: PropTypes.string,
	/**
	 * Mark the step as completed. Is passed to child components.
	 * @default false
	 */
	completed: PropTypes.bool,
	/**
	 * The label displayed in the step icon.
	 */
	icon: PropTypes.node,
};

const steps = [
	"Personal Information",
	"Linked Marketplaces",
	"Business Information",
	"Bank Information",
	// "Risk Analysis",
	"Upload Documents",
	"Successfully Completed",
];

export default function OnBoardingSteps({ onStepChange }) {
	const [activeStep, setActiveStep] = useState(0);
	// const [skipped, setSkipped] = useState(new Set());
	const hasRun = useRef(false);

	useEffect(() => {
		onStepChange?.(activeStep);
	}, [activeStep, onStepChange]);

	const updateStep = useCallback((value) => {
		setActiveStep(value);
	}, []);

	const navigate = useNavigate();

	useEffect(() => {
		if (hasRun.current) return;
		hasRun.current = true;

		const fetchData = async () => {
			try {
				await GetUserDetails(localStorage.getItem("uniqueId")).then((row) => {
					localStorage.setItem("businessOwnerIdType", row.businessOwnerIdType)
					switch (row.onboardingStatus) {
						case 'PENDING_EMAIL_VERIFICATION':
							setActiveStep(0);
							break;
						case 'PENDING_MARKETPLACE':
							setActiveStep(1);
							break;
						case 'PENDING_BUSINESS_DETAILS':
							setActiveStep(2);
							break;
						case 'PENDING_BANK_DETAILS':
							setActiveStep(3);
							break;
						case 'PENDING_DOCUMENTS':
							setActiveStep(4);
							break;
						case 'COMPLETE':
							setActiveStep(5);
							//setTimeout(() => navigate("/login"));
							break;
						case 'PENDING_DOCUMENT_APPROVAL':
							setActiveStep(5);
							break;
						case 'PENDING_BUSINESS_AGREEMENT':
							navigate("/onboarding/contract");
							break;
						case 'PENDING_FINAL_APPROVAL':
							navigate("/onboarding/contract");
							break;
						default:
						// setTimeout(() => navigate("/dashboard"));
					}
				});;

			} catch (error) {
				console.error('Error', error);;
			}
		};

		if (localStorage.getItem("uniqueId")) {
			fetchData();
		}
		// eslint-disable-next-line
	}, [])

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const markeplacelinked = urlParams.get("markeplacelinked");
		const emailVerified = urlParams.get("emailVerified");
		// const onboardingStatus = urlParams.get("onboardingStatus");

		if (markeplacelinked === 'true') {
			setActiveStep(2);
		}

		if (markeplacelinked === 'false') {
			setActiveStep(1);
		}

		if (emailVerified === 'true') {
			setActiveStep(1);
		}

		// if (onboardingStatus) {
		// 	setActiveStep(parseInt(onboardingStatus))
		// }

	}, [])

	// const isStepOptional = (step) => {
	// 	return step === 1;
	// };

	// const isStepSkipped = (step) => {
	// 	return skipped.has(step);
	// };

	// const handleNext = () => {
	// 	let newSkipped = skipped;
	// 	if (isStepSkipped(activeStep)) {
	// 		newSkipped = new Set(newSkipped.values());
	// 		newSkipped.delete(activeStep);
	// 	}

	// 	setActiveStep((prevActiveStep) => prevActiveStep + 1);
	// 	setSkipped(newSkipped);
	// };

	// const handleBack = () => {
	// 	setActiveStep((prevActiveStep) => prevActiveStep - 1);
	// };

	// const handleSkip = () => {
	// 	if (!isStepOptional(activeStep)) {
	// 		throw new Error("You can't skip a step that isn't optional.");
	// 	}

	// 	setActiveStep((prevActiveStep) => prevActiveStep + 1);
	// 	setSkipped((prevSkipped) => {
	// 		const newSkipped = new Set(prevSkipped.values());
	// 		newSkipped.add(activeStep);
	// 		return newSkipped;
	// 	});
	// };

	// const handleReset = () => {
	// 	setActiveStep(0);
	// };

	return (
		<Box sx={{ display: "flex", justifyContent: "center" }}>
			<Box
				component="main"
				sx={{ flexGrow: 1, pt: 5, pl: 10, pr: 10, maxWidth: 1024 }}
			>
				<Stepper
					alternativeLabel
					activeStep={activeStep}
					connector={<ColorlibConnector />}
				>
					{steps.map((label, index) => {
						return (
							<Step key={label}>
								<StepLabel StepIconComponent={ColorlibStepIcon}>
									<b>{label}</b>
								</StepLabel>
							</Step>
						);
					})}
				</Stepper>
				<br></br>
				{activeStep === steps.length ? (
					<Completed />
				) : (
					<React.Fragment>
						{activeStep === 0 ? (
							<PersonalInfo updateStep={updateStep} />
						) : activeStep === 1 ? (
							<LinkedMarketplaces updateStep={updateStep} />
						) : activeStep === 2 ? (
							<BusinessInfo updateStep={updateStep} />
						) : activeStep === 3 ? (
							<BankInfo updateStep={updateStep} />
						)
							//: activeStep === 4 ? (
							//   <RiskAnalysis updateStep={updateStep} />
							// ) 
							: activeStep === 4 ? (
								<UploadandSign updateStep={updateStep} />
							)
								: activeStep === 5 ? (
									<Completed />
								) : (
									""
								)}
						{/* <Box sx={{ display: "flex", flexDirection: "row", pt: 2, pb: 5 }}>
							<Button
								disabled={activeStep === 0}
								onClick={handleBack}
								sx={{ mr: 1, color: "#f9f9fb !important" }}
								startIcon={<ArrowBackIosNewIcon />}
							>
								Previous
							</Button>
							<Box sx={{ flex: "1 1 auto" }} />
							{isStepOptional(activeStep) && (
								<Button onClick={handleSkip} sx={{ mr: 1, color: "#f9f9fb !important" }}>
									Skip
								</Button>
							)}
							<Button
								onClick={handleNext}
								endIcon={<ArrowForwardIosIcon />}
								sx={{ color: "#f9f9fb" }}
							>
								{activeStep === steps.length - 1 ? "Finish" : "Next"}
							</Button>
						</Box> */}
					</React.Fragment>
				)}
			</Box>
		</Box>
	);
}
